import { datadogRum } from '@datadog/browser-rum';
import type { Context } from '@datadog/browser-rum';

import noop from 'utils/noop';

export const rumWrapperStartView = (_key: string, name: string, context?: Context) =>
  datadogRum.startView({ name, context });

export const rumWrapperStopView = noop;
